export default "__VITE_ASSET__CGqtA$5u__"